import script from "./VRSimulation.vue?vue&type=script&lang=ts&setup=true"
export * from "./VRSimulation.vue?vue&type=script&lang=ts&setup=true"

import "./VRSimulation.vue?vue&type=style&index=0&id=6143a958&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6143a958"]])

export default __exports__